import { Brand } from "effect"
import { Link as RRLink, type LinkProps } from "react-router"

export const Link = (props: Link.Props) => {
  return <RRLink viewTransition {...props} />
}

export type Route = Brand.Branded<string, "CheckIn/Route">
const Route = Brand.nominal<Route>()

// TODO: brand these ID's
export const Routes = {
  // auth
  verifyOtp: Route("/auth/verify-otp"),
  resendOtp: Route("/auth/resend-otp"),
  authenticate: Route("/auth/authenticate"),
  logout: Route("/auth/logout"),

  // app
  landing: Route("/check-in"),
  login: Route("/check-in/login"),
  createCheckIn: Route("/check-in/create"),
  verifyLocation: Route("/check-in/verify-location"),
  createRequest: Route("/check-in/create-request"),
  verify: Route("/check-in/verify"),
  confirmation: Route("/check-in/confirmation"),
  profile: Route("/profile"),
}

namespace Link {
  export type Props = Omit<LinkProps, "to"> & {
    to: Route
  }
}
